export const comments_5588989 = {"data":{"data":[],"links":{}}}